import { LOCALE_LABELS, resolveLocale, SUPPORTED_LOCALES } from '@upme/i18n';
import { useTranslation } from 'react-i18next';
import { LOCALE_CACHE_KEY } from '../../i18n/detect';

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = resolveLocale(i18n.language);
  return (
    <div className="flex gap-2">
      {SUPPORTED_LOCALES.map((loc) => (
        <button
          type="button"
          key={loc}
          onClick={() => {
            void i18n.changeLanguage(loc);
            try {
              localStorage.setItem(LOCALE_CACHE_KEY, loc);
            } catch {
              // ignore
            }
          }}
          className={current === loc ? 'font-semibold underline' : 'text-muted-foreground'}
        >
          {LOCALE_LABELS[loc]}
        </button>
      ))}
    </div>
  );
}
